import { IconSuccess16, IconToggleFavoriteOn12, TooltipDesktop, UIHeading6, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SuperAgentLevelView.css';

type TSuperAgentLevelViewProps = {
  tooltip: string[];
};

export const SuperAgentLevelView: React.FC<TSuperAgentLevelViewProps> = ({ tooltip }) => {
  const key = React.useId();

  return (
    <TooltipDesktop
      theme="white"
      title={
        <ul className={styles['tooltip']}>
          {tooltip.map((item, i) => (
            <li key={`${key}${i}`} className={styles['item']}>
              <IconSuccess16 color="success_100" />
              <UIText2>{item}</UIText2>
            </li>
          ))}
        </ul>
      }
      placement="bottom"
    >
      <div className={styles['wrapper']}>
        <div className={styles['circle']}>
          <IconToggleFavoriteOn12 color="white_100" />
        </div>
        <UIHeading6 color="success_100">Суперагент</UIHeading6>
      </div>
    </TooltipDesktop>
  );
};
